import request from '@/utils/request'

export const getCategoryList = params => request.get('/todo/category', { params })

export const createCategory = data => request.post('/todo/category', data)

export const updateCategory = (id, data) => request.put(`/todo/category/${id}`, data)

export const deleteCategory = id => request.delete(`/todo/category/${id}`)

export const getCategory = id => request.get(`/todo/category/${id}`)

export const getTodoList = data => request.post('/todo/todo', data)

export const getTodoDetail = id => request.get(`/todo/todo/${id}`)
